import React, { useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function AlbumViewer({ items, onClose }) {
  const [view, setView] = useState("grid"); // grid | viewer
  const [start, setStart] = useState(0);

  return (
    <div className="fixed inset-0 z-[95] bg-black/95 backdrop-blur-xl flex flex-col" data-testid="album-viewer">
      <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
        <h3 className="font-heading text-2xl text-white">Media · {items.length}</h3>
        <button onClick={onClose} data-testid="album-close-btn" className="h-9 w-9 grid place-items-center rounded-full text-white/70 hover:text-[var(--rc-gold)]"><X size={22} /></button>
      </div>

      {view === "grid" ? (
        <div className="flex-1 overflow-y-auto p-4">
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
            {items.map((it, i) => (
              <button key={i} onClick={() => { setStart(i); setView("viewer"); }} data-testid={`album-thumb-${i}`}
                className="relative aspect-square rounded-xl overflow-hidden border border-white/10 group">
                {it.type === "video" ? (
                  <><video src={it.url} className="w-full h-full object-cover" />
                    <span className="absolute inset-0 grid place-items-center bg-black/30 text-white text-2xl">▶</span></>
                ) : (
                  <img src={it.url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                )}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <Swiper items={items} startIndex={start} onBackToGrid={() => setView("grid")} />
      )}
    </div>
  );
}

function Swiper({ items, startIndex, onBackToGrid }) {
  const [emblaRef, embla] = useEmblaCarousel({ startIndex, loop: false });
  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-1 overflow-hidden" ref={emblaRef}>
        <div className="flex h-full">
          {items.map((it, i) => (
            <div key={i} className="flex-[0_0_100%] min-w-0 h-full grid place-items-center p-4">
              {it.type === "video"
                ? <video src={it.url} controls className="max-h-full max-w-full rounded-xl" />
                : <img src={it.url} alt="" className="max-h-full max-w-full object-contain rounded-xl" />}
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-center gap-6 py-5">
        <button onClick={() => embla && embla.scrollPrev()} data-testid="album-prev" className="h-11 w-11 grid place-items-center rounded-full bg-white/10 text-white"><ChevronLeft size={22} /></button>
        <button onClick={onBackToGrid} className="text-sm text-white/70 hover:text-[var(--rc-gold)]" data-testid="album-back-grid">Back to grid</button>
        <button onClick={() => embla && embla.scrollNext()} data-testid="album-next" className="h-11 w-11 grid place-items-center rounded-full bg-white/10 text-white"><ChevronRight size={22} /></button>
      </div>
    </div>
  );
}
